import React from "react";
import {Col, Row} from "reactstrap";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ProgressShipmentComponent from "./ProgressShipmentComponent";
import Pickup from "../../../Models/Pickup";
import moment from 'moment';
import Shipment from "../../../Models/Shipment";
import {useDispatch} from "react-redux";
import {ModalActions} from "../../../Store/Modal/Slice";
import {SHIPMENT_PROVE_MODAL} from "../../../Store/Modal/Types";

type Props = {
  data: Pickup | Shipment;
  isShipment: boolean;
}

const DetailShipmentComponent: React.FC<Props> = ({ isShipment, data}) => {

  const dispatch = useDispatch();

  const openShipmentProve = () => {
    dispatch(ModalActions.openModal({modal: SHIPMENT_PROVE_MODAL, data}));
  };

  return (
    <div className="mx-2">
      <span className="d-block pb-4">Fecha de envío: {' '}
      <b className="text-danger">
        { isShipment ? moment((data as any)?.pickup_date).format('DD/MM/yyyy') :
        moment((data as any)?.call_date).format('DD/MM/yyyy')}
      </b></span>
      <Row className="mb-4 mx-2">
        <Col className="aur-border-card-info" lg={6}>
          <b>Datos remitente</b>
          <div className="ml-3">
            <span className="d-block">
              Nombre: {' '}
              <b
                className="text-danger text-uppercase">
                { isShipment ?
                  `${(data as any)?.pickup?.contact_pickup?.name} ${(data as any)?.pickup?.contact_pickup?.last_name}` : `
                   ${(data as any)?.contact_pickup?.name} ${(data as any)?.contact_pickup?.last_name}`}
              </b>
            </span>

            <span className="d-block">
              Unidad de empaque: {' '}
              <b className="text-danger text-uppercase">
                {isShipment ? (data as any)?.pickup?.packing_type?.name : (data as any)?.packing_type?.name}
              </b>
            </span>

            <span className="d-block">
              Origen: {' '}
              <b className="text-danger text-uppercase">
                { isShipment ? (data as any)?.pickup_address?.city?.name : (data as any)?.address?.city?.name}
              </b>
            </span>
          </div>
        </Col>

        <Col lg={6}>
          <b>Datos destinatario</b>
          <div className="ml-3">
            <span className="d-block">
              Nombre: {' '}
              <b className="text-danger text-uppercase">
                {isShipment ? `${(data as any)?.receiver?.name} ${(data as any)?.receiver?.last_name} ` : ''}
              </b>
            </span>

            <span className="d-block">
              Destino: {' '}
              <b className="text-danger text-uppercase">
                {isShipment ? `${(data as any)?.receiver?.city?.name}` : ''}
              </b>
            </span>
          </div>
        </Col>
      </Row>

      {isShipment &&
        <Col className="my-3">
          <ProgressShipmentComponent shipment={data as Shipment}/>
        </Col>
      }

      <Col className="text-center mb-3">
        <span className="d-block">Estado:</span>
        <h4>
          <b className="text-danger text-uppercase">
            {data?.status}
          </b>
        </h4>
      </Col>


      {(data as Shipment)?.pickup &&
        <Row className="aur-dashed-border mx-2 py-3 text-center">
        <Col className="pb-4 pb-sm-0 aur-border-card-info" lg={ (data as Shipment)?.delivery_date ? 6 : 12}>
          <span className="text-uppercase d-block">
            Entrega digitalizada en {(data as any)?.address?.city?.name}
          </span>

          <b> Ver guía </b>
          <FontAwesomeIcon onClick={openShipmentProve} color="red" className="ml-1 clickable" icon={faDownload}/>
        </Col>

          {(data as Shipment)?.delivery_date &&
            <Col className="aur-border-date" lg={6}>
          <span className="d-block">
            Fecha de entrega:{' '}
            <b className="text-danger text-uppercase">
              {moment((data as Shipment)?.delivery_date).format('DD/MM/YYYY')}
            </b>
          </span>

            <span className="d-block">
            Hora:{' '}
              <b className="text-danger text-uppercase">
              {moment((data as Shipment)?.delivery_date).format('h:mm a')}
            </b>
          </span>
          </Col>}
      </Row>}
    </div>
  );
};

export default DetailShipmentComponent;
